import { render, staticRenderFns } from "./TaxCodeDetails.vue?vue&type=template&id=48274fc9&scoped=true&"
import script from "./TaxCodeDetails.vue?vue&type=script&lang=js&"
export * from "./TaxCodeDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaxCodeDetails.vue?vue&type=style&index=0&id=48274fc9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48274fc9",
  null
  
)

export default component.exports